import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { ContactRequestModel, ContactResponseModel } from '../models/contacts.model';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private readonly _backend = inject(BackendService);

  getAll(
    options?: HttpOptions
  ): Observable<PaginatedResponseModel<ContactResponseModel[]>> {
    return this._backend.get(`/contacts`, options);
  }

  create(data: ContactRequestModel, options?: HttpOptions) {
    return this._backend.post(`/contacts`, data, options);
  }

  update(contactId: string, data: ContactRequestModel, options?: HttpOptions) {
    return this._backend.put(`/contacts/${contactId}`, data, options);
  }

  delete(contactId: string) {
    return this._backend.delete(`/contacts/${contactId}`);
  }
}
